import { UserLicense } from "client/Api/FeaturePackages/featurePackageManagement";
import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";

export function getUserLicenseName(kind: UserLicense): string {
	return localize(userLicenseToLocalizationKey[kind]);
}

const userLicenseToLocalizationKey: { [key in UserLicense]: LocalizationKey; } = {
	[UserLicense.Simplify]: "_(License)Simplify",
	[UserLicense.Connect]: "_(License)Connect"
};

export enum EnvironmentFeature {
	CitrixXenApp = 1,
	ClientlessRdpApp = 2,
	AzureVirtualDesktopApp = 3,
	FileServerWebDav = 4,
	VmwareHorizonApp = 5,
	Liquit = 6,
	Hub = 7,
	MicrosoftTeamsApp = 8,
	RssApp = 9,
	Birthdays = 10,
	VivaEngageApp = 11,
	ManagedSignature = 12,
	MicrosoftToDoApp = 13,
	SharePointApp = 14,
	AddressBook = 15,
	YoutubeApp = 16,
	Afas = 17,
	ZenyaDoc = 18,
	VilansKick = 19,
	Autotask = 20,
	Zaaksysteem = 21,
	Zermelo = 22,
	TopDesk = 23,
	NedapOns = 24,
	Magister = 25,
	Egnyte = 27,
	ConnectWise = 28,
	Sibi = 29,
	AiAssistant = 31,
	Intercom = 34,
	IntegrationFramework = 35,
	Nextcloud = 36
}

export function getRequiredUserLicenseForEnvironmentFeature(
	environmentFeature: EnvironmentFeature
): UserLicense {
	switch (environmentFeature) {
		case EnvironmentFeature.AddressBook:
		case EnvironmentFeature.AiAssistant:
		case EnvironmentFeature.AzureVirtualDesktopApp:
		case EnvironmentFeature.Birthdays:
		case EnvironmentFeature.CitrixXenApp:
		case EnvironmentFeature.ClientlessRdpApp:
		case EnvironmentFeature.FileServerWebDav:
		case EnvironmentFeature.Hub:
		case EnvironmentFeature.IntegrationFramework:
		case EnvironmentFeature.Liquit:
		case EnvironmentFeature.ManagedSignature:
		case EnvironmentFeature.MicrosoftTeamsApp:
		case EnvironmentFeature.MicrosoftToDoApp:
		case EnvironmentFeature.Nextcloud:
		case EnvironmentFeature.RssApp:
		case EnvironmentFeature.SharePointApp:
		case EnvironmentFeature.VivaEngageApp:
		case EnvironmentFeature.VmwareHorizonApp:
		case EnvironmentFeature.YoutubeApp:
			return UserLicense.Simplify;
		case EnvironmentFeature.Afas:
		case EnvironmentFeature.Autotask:
		case EnvironmentFeature.Egnyte:
		case EnvironmentFeature.Magister:
		case EnvironmentFeature.NedapOns:
		case EnvironmentFeature.Sibi:
		case EnvironmentFeature.TopDesk:
		case EnvironmentFeature.VilansKick:
		case EnvironmentFeature.Zaaksysteem:
		case EnvironmentFeature.ZenyaDoc:
		case EnvironmentFeature.Zermelo:
		case EnvironmentFeature.ConnectWise:
		case EnvironmentFeature.Intercom:
			return UserLicense.Connect;
		default:
			never(environmentFeature);
	}
}
